{
	"publishFailedTitle": "Publish Failed",
	"publishFailedMessage": "Publish failed due to a network connectivity error. Please check your internet connection and try again."
}
